// app/adminSL/risorsa/asl_risorse.js

(function () {
    'use strict';
    var controllerId = 'asl_risorsa';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$routeParams', '$filter', '$uibModal', 'datacontext', 'sectionMenu', asl_risorsaFn]);

    function asl_risorsaFn(common, bDialog, $rootScope, $routeParams, $filter, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Docenti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
                
        vm.objName = "risorsa"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.readOnly = true;
        vm.super = false;
        vm.gestDid = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Cognome', 'Codice Fiscale', 'Email', 'Istituto', 'Data Fine Licenza Decr', 'Data Fine Licenza Cres'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.incarichi = [];

        vm.getRecord = getRecord;
        vm.getListIncarichi = getListIncarichi;
        vm.getComuni = getComuni;

        //Filtro
        vm.filter = {};
        vm.filter.ricerca = '';
        vm.fRicerca = '';
              
        //Elenchi per filtri e finestra modale di Create        
        vm.provincie = [];
        vm.comuni = [];
        vm.societa = [];

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;        
        vm.get = getRecord;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.RisorsaId != null) {
                            setView('detail');
                            getRecord($routeParams.RisorsaId, 0);
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.asl_risorsa_countAll(vm.filter.ricerca).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;            
            vm.loading = true;
            return datacontext.asl_risorsa_getAll(vm.pageSize, vm.page, vm.filter.ricerca, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            if (vm.provincie.length == 0) getProvincie();

            return datacontext.risorsa_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.numIncarichi = data.stat_numIncarichi;
                //Azzera liste
                getComuni(vm.record.ProvinciaId);
                vm.list.incarichi = [];

                setView('detail');
            });
        }               

        //Elenchi dettagli
        function getListIncarichi(id) {
            return datacontext.incarico_getAllByRisorsa(id).then(function (data) {
                vm.numIncarichi = data.length;
                if (data.constructor === Array) {
                    vm.record.sumOreDocenze = 0;
                    data.forEach(function (data) {
                        vm.record.sumOreDocenze += data.Ore;
                    });
                }
                return vm.list.incarichi = data;
            });
        }

        function getProvincie() {
            if (vm.provincie.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.provincie = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }

        function getListClassi() {
            return datacontext.classe_getAllList(-1).then(function (data) {
                return data;
            });
        }        
    }
})();
